const defaultParam = { times: 20, interval: 200 };
const waitUntil = (getIsReady, { times = defaultParam.times, interval = defaultParam.interval } = defaultParam) => {
    let counter = 0;
    return new Promise((resolve, reject) => {
        const intervalId = setInterval(() => {
            if (counter < times) {
                if (getIsReady()) {
                    clearInterval(intervalId);
                    // @ts-expect-error ts-migrate(2794) FIXME: Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
                    resolve();
                }
                else {
                    counter += 1;
                }
            }
            else {
                clearInterval(intervalId);
                reject();
            }
        }, interval);
    });
};
export default waitUntil;
//# sourceMappingURL=waitUntil.js.map